import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useGetVideoQuizSubmission = (contentIds, userIds) => {
  const queryParams = {
    interactive_video_ids: contentIds,
    submitted_by_users: userIds,
  };
  const queryString = new URLSearchParams(queryParams);

  const requestUrl = `${API_BASE_URL}/api/v3/interactive-video-link-quiz-submission/?${queryString}`;
  return useRestQuery(requestUrl);
};

export default useGetVideoQuizSubmission;
